export default {"src":"/_next/static/media/notes-list.8ba1a048.svg","height":402,"width":403,"blurWidth":0,"blurHeight":0};